// Simple, robust API configuration
// Use REACT_APP_API_URL from .env, fallback to hostname detection
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const isCustomDomain = window.location.hostname === 'weheal.live' || window.location.hostname === 'www.weheal.live';
const isRenderDomain = window.location.hostname === 'weheal-frontend.onrender.com';

const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (isLocalhost 
    ? 'http://localhost:5001/api' 
    : isCustomDomain
    ? 'https://api.weheal.live/api'
    : isRenderDomain
    ? 'https://weheal-backend.onrender.com/api'
    : 'https://weheal-backend.onrender.com/api'); // fallback

console.log('API Configuration:', { 
  hostname: window.location.hostname, 
  isLocalhost, 
  isCustomDomain,
  isRenderDomain,
  API_BASE_URL,
  envUrl: process.env.REACT_APP_API_URL 
});

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  AUTH_URL: `${API_BASE_URL}/auth`,
  TIMEOUT: 10000, // 10 seconds
};

export default API_CONFIG;
